export default "__VITE_ASSET__B72CyfGs__"